import { useState } from "react";
import { Typography, TextField, Box, Snackbar, Alert } from "@mui/material";

import WDBox from "../../../MaterialComponents/WDBox";
import BasicLayout from "../../../LayoutContainers/BasicLayout";
import WDButton from "../../../MaterialComponents/WDButton";
import { useNavigate } from "react-router-dom";

import { Formik, Form, Field } from "formik";
import { object, string } from "yup";
import axios from 'axios';
import AppService from "../../../Configurations/Appservice";
import { formCard, formPanel, rightPanel, rootBox } from "../Login/styles";
import logo from "../../../assets/images/Logo.jpeg";

const ForgotPage = () => {
  const navigate = useNavigate();

  const [showError, setShowError] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setShowError(false);
  };

  const initialValues = {
    email: "",
  };

  const validationSchema = object({
    email: string().required("Email id is Mandatory"),
  });

  const [isLoading, loading] = useState(false);

  const [errorMessage, setErrorMessage] = useState();
  const [successMessage, setSuccessMessage] = useState("");

  const _forgotHandler = (values, formikHelpers) => {
    
    loading(true);
    AppService.post(`/api/auth/forgot-password?email=${values.email}`)
      .then((response) => {
        console.log(response);
        setSuccessMessage(response || "Instructions to reset your password have been sent to your email");
        setShowSuccess(true);
        setTimeout(() => {
            navigate("/");
        },2000);
      })
      .catch((error) => {
        setErrorMessage("Forgot request failed ,Please try again");
        setShowError(true);
      })
      .finally(() => {
        loading(false);
      });
  };

    return (
      <BasicLayout>
        <Snackbar open={showError} autoHideDuration={2000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={{ width: "100%" }}>
            {errorMessage}
          </Alert>
        </Snackbar>

        <Snackbar open={showSuccess} autoHideDuration={2000} onClose={() => setShowSuccess(false)}>
            <Alert severity="success" sx={{ width: "100%" }}>
                {successMessage}
            </Alert>
        </Snackbar>


        <Box sx={rootBox}>
          <Box sx={formPanel}>
            <Typography color="white.main" sx={{ my: 2 }}>
              Enter Your Mail To Reset Password
            </Typography>
            <Box sx={formCard}>
              <Formik
                initialValues={initialValues}
                onSubmit={_forgotHandler}
                validationSchema={validationSchema}
              >
                {({ errors, isValid, touched, dirty }) => (
                  <Form>
                    <WDBox mb={2}>
                      <Field
                        name="email"
                        label="Email Id"
                        fullWidth
                        as={TextField}
                        error={Boolean(errors.email) && Boolean(touched.email)}
                        helperText={Boolean(touched.email) && errors.email}
                        inputProps={{ style: { color: "white" } }}
                      />
                    </WDBox>
                    <WDButton
                      variant="contained"
                      fullWidth
                      disabled={!dirty || !isValid}
                      type="submit"
                      sx={{ 
                        backgroundColor: '#064d51 !important',
                        '&:hover': { backgroundColor: '#053a3d !important' },
                        color: 'white',
                        fontWeight: 'bold',
                        textTransform: 'uppercase',
                        padding: '10px 0',
                        borderRadius: '4px',
                        boxShadow: '0 4px 6px rgba(0,0,0,0.1)'                       
                      }}
                    >
                      {isLoading ? "Submit..." : "Submit"}
                    </WDButton>
                    <Typography
                      variant="body2"
                      sx={{ mt: 2, textAlign: "center", cursor: "pointer", color: "white.main" }}
                      onClick={() => navigate("/")}
                    >
                      Return to Login
                    </Typography>
                  </Form>
                )}
              </Formik>
            </Box>{" "}
          </Box>
          <Box sx={rightPanel}>
            <Box component="img" src={logo} sx={{ height: "30%", width: "auto" }} />
            {/* <img src={logo} sx={{ height: 10, width: 10 }} /> */}
          </Box>
        </Box>
      </BasicLayout>
    );
};

export default ForgotPage;
